module.exports = function getResource (label) {
    let resources = {
        default: 'Par défaut'
    };

    return resources[label];
};
